import React, { Fragment, useReducer, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { formatTimeZone, priceFormat, addRankToEntries } from './../../../utils/helpers'
import PopComponent from "../Popup/PopupComponent";

const AwardPreviewImage = ({entry = {}, className = '', previewLink}) => {
  const navigate = useNavigate()

  const [isShowImage, setShowImage] = useState(false)
  const [imageSelected, setImageSelected] = useState(null)

  const handleShowImage = (image) => {
    if (previewLink) {
      navigate(previewLink)
      return
    }
    setShowImage(true)
    setImageSelected(image)
  }

  const _handleCloseModal = () => {
    setShowImage(false)
    setImageSelected(null)
  }

  return (
    <Fragment>
      <img
        src={entry?.photo?.photo_url?.thumbnail}
        onClick={() => handleShowImage(entry?.photo ?? null)}
        className={className}
        // alt={entry?.user?.nickname}
      />

      {imageSelected && (
        <PopComponent
          id={"MD6"}
          show={isShowImage}
          handleClose={_handleCloseModal}
          style={{ width: "calc(100vw - 50px"}}
          // bodyStyle={{height: "80vh"}}
          headingStyle={{borderBottom: "2px solid rgb(17 17 17 / 20%)"}}
          title={"이미지 상세보기"}
        >
          <div className="modal-voting-avatar-user d-flex justify-content-center">
            <div className="modal-voting-avatar-user__item">
              <img
                className="modal-voting-avatar-user__item__avatar"
                src={imageSelected?.photo_url?.original}
                alt=""
              />
              <p className="modal-voting-avatar-user__item__bthday">
                {formatTimeZone(entry?.created_at || imageSelected?.created_at)}
              </p>
            </div>
          </div>
        </PopComponent>
      )}
    </Fragment>
  )
}

export default AwardPreviewImage;
